import { Language } from '../shared/types';

export const languages: Language[] = [
  { id: 'ko', label: '한국어', icon: '🇰🇷' },
  { id: 'en', label: 'English', icon: '🇺🇸' },
  { id: 'zh', label: '中文', icon: '🇨🇳' },
  { id: 'ja', label: '日本語', icon: '🇯🇵' },
  { id: 'vi', label: 'Tiếng Việt', icon: '🇻🇳' },
];
